/* tslint:disable */
/* eslint-disable */
/**
 * Notes API
 * API for managing notes with tags, mentions and attachments
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TagNoteDto } from './TagNoteDto';
import {
    TagNoteDtoFromJSON,
    TagNoteDtoFromJSONTyped,
    TagNoteDtoToJSON,
    TagNoteDtoToJSONTyped,
} from './TagNoteDto';

/**
 * Response containing list of tags
 * @export
 * @interface SearchTagsNotesResponse
 */
export interface SearchTagsNotesResponse {
    /**
     * List of matching tags
     * @type {Array<TagNoteDto>}
     * @memberof SearchTagsNotesResponse
     */
    tags?: Array<TagNoteDto>;
}

/**
 * Check if a given object implements the SearchTagsNotesResponse interface.
 */
export function instanceOfSearchTagsNotesResponse(value: object): value is SearchTagsNotesResponse {
    return true;
}

export function SearchTagsNotesResponseFromJSON(json: any): SearchTagsNotesResponse {
    return SearchTagsNotesResponseFromJSONTyped(json, false);
}

export function SearchTagsNotesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchTagsNotesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tags': json['tags'] == null ? undefined : ((json['tags'] as Array<any>).map(TagNoteDtoFromJSON)),
    };
}

export function SearchTagsNotesResponseToJSON(json: any): SearchTagsNotesResponse {
    return SearchTagsNotesResponseToJSONTyped(json, false);
}

export function SearchTagsNotesResponseToJSONTyped(value?: SearchTagsNotesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tags': value['tags'] == null ? undefined : ((value['tags'] as Array<any>).map(TagNoteDtoToJSON)),
    };
}

